import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getGprAvailableColumns, getGprRunAvailableColumns } from './api';

export const path = '/gpr';

// Справочники здесь не грузим: форма графика (PageGprForm) тянет свои сама, а справочники
// фильтров DynamicTable запрашивает сам при открытии мультиселекта. page.tsx принимает две
// схемы колонок: gprColumns — для списка графиков, columns — для реестра запусков.
const PageGpr: React.FC = (props) => {
  const Gpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getGprRunAvailableColumns,
      gprColumns: getGprAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <Gpr {...props} />;
};

export default PageGpr;
